import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    itemId: String,
    itemName: String
  }

  updateQuantity(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'update_quantity', {
        item_id: this.itemIdValue,
        item_name: this.itemNameValue,
        quantity: event.detail.quantity
      })
    }
  }

  removeItem(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'remove_item', {
        item_id: this.itemIdValue,
        item_name: this.itemNameValue
      })
    }
  }
}